import { handleActions } from "redux-actions";
import {
  SET_REVENUE_TYPES_CHECKED,
  SET_UPDATES_LOADING,
  SET_LOADING,
  SET_PREV_PAGE_FILTERS,
  UPDATE_ROLLING_VIEW,
  SET_CHART_LOADING,
  FETCH_REVENUE_BY_TYPE_SUCCESS,
  FETCH_YEAR_OVER_YEAR_SUCCESS,
  FETCH_REVENUE_TYPES_SUCCESS,
  FETCH_CURRENT_USER_SUCCESS,
  FETCH_REVENUE_SUCCESS,
  UPDATE_REVENUE_TYPES_SUCCESS,
  REMOVE_REVENUE_CATEGORY_SUCCESS,
  REMOVE_REVENUE_CATEGORY,
  ADD_REVENUE_CHART_SUCCESS
} from "./totalRevenueSagas";

export const initialState = {
  allRevenues: {},
  prevPageFilters: { prevDate: null, prevRevenueType: null },
  initRequest: false,
  currencySymbol: "",
  currentUser: {},
  revenuesByType: [],
  revenuesTypes: [],
  isUpdating: false,
  defaultCheckedItems: [],
  yearOverYearComparison: [],
  initialized: false,
  rolling_view: true,
  checkedRevenueTypeIds: {},
  revenueTypesCheckedMax: false,
  isLoading: true,
  isChartLoading: true
};

const getDefaultCheckedTypeIds = (items) => {
  let ids = [];
  items?.forEach((item) => {
    if (item.selected) {
      ids.push({ id: item.id, type: item.type });
    }
    if (item.items) {
      ids = ids.concat(getDefaultCheckedTypeIds(item.items));
    }
  });
  return ids;
};

export default handleActions(
  {
    [SET_LOADING]: (state, action) => ({
      ...state,
      isLoading: action.payload
    }),
    [SET_CHART_LOADING]: (state, action) => ({
      ...state,
      isChartLoading: action.payload
    }),
    [SET_PREV_PAGE_FILTERS]: (state, action) => ({
      ...state,
      prevPageFilters: { ...action.payload }
    }),
    [SET_UPDATES_LOADING]: (state, action) => ({
      ...state,
      isUpdating: action.payload
    }),
    [FETCH_CURRENT_USER_SUCCESS]: (state, action) => ({
      ...state,
      currentUser: action.payload || state.currentUser,
      initRequest: true
    }),
    [UPDATE_ROLLING_VIEW]: (state, action) => ({
      ...state,
      rolling_view: action.payload,
    }),
    [REMOVE_REVENUE_CATEGORY]: (state, action) => ({
      ...state,
      isUpdating: true,
      revenuesByType: state.revenuesByType.filter(
        (rev) => rev.id !== action.payload.id && rev.type !== action.payload.type
      )
    }),
    [FETCH_REVENUE_SUCCESS]: (state, action) => ({
      ...state,
      initialized: action.payload.initialized || state.initialized,
      allRevenues: action.payload.totalRevenues || state.allRevenues
    }),
    [FETCH_REVENUE_BY_TYPE_SUCCESS]: (state, { payload: { revenuesByType = [] } }) => ({
      ...state,
      revenuesByType: revenuesByType
    }),
    [FETCH_REVENUE_TYPES_SUCCESS]: (state, { payload: { revenuesTypes = [] } }) => {
      const checkedRevenueTypeIds = getDefaultCheckedTypeIds(revenuesTypes);

      return {
        ...state,
        revenuesTypes: revenuesTypes,
        defaultCheckedItems: checkedRevenueTypeIds,
        checkedRevenueTypeIds: checkedRevenueTypeIds
      };
    },
    [UPDATE_REVENUE_TYPES_SUCCESS]: (state, { payload: { revenuesByType = [] } }) => ({
      ...state,
      revenuesByType: revenuesByType,
      defaultCheckedItems: state.checkedRevenueTypeIds
    }),
    [FETCH_YEAR_OVER_YEAR_SUCCESS]: (
      state,
      { payload: { revenuesYearOverYearComparison = [] } }
    ) => ({
      ...state,
      yearOverYearComparison: revenuesYearOverYearComparison.slice(0, 13)
    }),
    [SET_REVENUE_TYPES_CHECKED]: (state, action) => ({
      ...state,
      checkedRevenueTypeIds: action.payload
    }),
    [ADD_REVENUE_CHART_SUCCESS]: (state, action) => ({
      ...state,
      revenuesByType: action.payload.revenuesByType
    }),
    [REMOVE_REVENUE_CATEGORY_SUCCESS]: (state, { payload: { revenuesByType = [] } }) => ({
      ...state,
      isUpdating: false,
      revenuesByType: revenuesByType,
      defaultCheckedItems: revenuesByType,
      checkedRevenueTypeIds: revenuesByType
    })
  },
  initialState
);
